import * as ko from 'knockout';
import $ from 'jquery';
import 'select2';
export default class Select2 {
    public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
        $(element).select2();
    }
}
ko.bindingHandlers['select2'] = new Select2();
